import { useTranslation } from 'react-i18next';
import { ListContentIsland } from '@razz-team/ui-web';
import { useActiveDigitalWalletTokenList } from '../../../api/digital-wallet-tokens';
import { DigitalWalletTokenListItem } from '../../DigitalWalletToken/DigitalWalletTokenListItem';

export function DigitalWalletTokenList() {
  const { t } = useTranslation();
  const filtered = useActiveDigitalWalletTokenList();

  if (!filtered.length) return null;

  return (
    <ListContentIsland title={t('Wallet requests')}>
      {filtered.map((it) => (
        <DigitalWalletTokenListItem key={it.id} token={it} />
      ))}
    </ListContentIsland>
  );
}
